import React, { Component } from "react";
import {
  Table,
  Pagination,
  Col,
  Row,
  Select,
  Button,
  Tag,
  DatePicker
} from "antd";
import moment from "moment";
import ReactDragListView from "react-drag-listview";

export default class WeeklyNewsView extends Component {
  render() {
    const {
      isProcessing,
      articles,
      moveToArticleUrl,
      deleteSelectedArticle,
      updateArticleOrder,
      saveUpdatedOrder
    } = this.props;

    const that = this;
    const dragProps = {
      onDragEnd(fromIndex, toIndex) {
        const data = [...articles];
        const item = data.splice(fromIndex, 1)[0];
        data.splice(toIndex, 0, item);
        updateArticleOrder(data);
      },
      lineClassName: "primary-colored-line",
      handleSelector: "a"
    };

    const columns = [
      {
        title: "News Heading",
        key: "news_heading",
        width: 150,
        align: "left",
        render: record => (
          <div className="news-article-heading">
            <span
              data-type="link"
              onClick={() => moveToArticleUrl(record)}
            >
              {" "}
              {record.news_type === "CME" ? record.event_name : record.title}
            </span>
          </div>
        )
      },
      {
        title: "Type",
        align: "left",
        render: record => <div>{record.news_type || "--"}</div>
      },
      {
        title: "Date",
        key: "date",
        align: "left",
        render: record => (
          <div>{moment(record.news_date).format("DD-MM-YYYY") || "--"}</div>
        )
      },
      {
        title: "Source",
        key: "expiry",
        align: "left",
        render: record => (
          <div>
            <div className="tbl-news-source-container">
              {record.source_thumbnail_url && (
                <div className="source-thumbnail-img">
                  <img src={record.source_thumbnail_url} />
                </div>
              )}

              <div className="source-name">{record.source_name}</div>
            </div>
          </div>
        )
      },
      {
        title: "Publish",
        key: "publish",
        align: "left",
        render: record => (
          <div>
            {record.published ? (
              <span className="text-green">Yes</span>
            ) : (
              <span className="text-red">No</span>
            )}{" "}
          </div>
        )
      },
      {
        title: "Tags",
        key: "tags",
        align: "left",
        render: record => (
          <div>
            {record.news_tags.map(item => (
              <Tag className="mb-5" color="green">
                {item.tag_name}
              </Tag>
            ))}
          </div>
        )
      },
      {
        title: "Shared Views",
        key: "viewed_count",
        align: "left",
        render: record => <div>{record.viewed_count}</div>
      },
      {
        title: "Shared Clicks",
        key: "shared_count",
        align: "left",
        render: record => <div>{record.shared_count}</div>
      },
      {
        title: "Operates",
        key: "operate",
        render: (text, record, index) => (
          <a className="drag-handle" href="#">
            Drag
          </a>
        )
      },
      {
        align: "left",
        width: 100,
        render: record => (
          <div>
            {
              <Button
                type="default"
                shape="circle"
                icon="delete"
                onClick={() => deleteSelectedArticle(record.id)}
              />
            }
          </div>
        )
      }
    ];

    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row type="flex" justify="space-between">
            <Col className="heading-domain pl-0">Weekly News Feed</Col>
            <Col>
              <Button type="primary" onClick={saveUpdatedOrder}>
                Update news sequence
              </Button>
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x">
            <ReactDragListView {...dragProps}>
              <Table
                columns={columns}
                dataSource={articles}
                pagination={false}
                rowKey="id"
                loading={isProcessing}
              />
            </ReactDragListView>
          </div>
        </div>
      </div>
    );
  }
}
